function matchheight() {
    if (window.innerWidth > 991) {
        var container = document.getElementById('container');
        if (container) {
            var rect = container.getBoundingClientRect();
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

            var top = rect.top + scrollTop;
            var left = rect.left + scrollLeft + 15;

            var ribContentSecs = document.querySelectorAll('.rib_content_sec');
            ribContentSecs.forEach(function (el) {
                el.style.paddingLeft = left + 'px';
            });

            var rightElems = document.querySelectorAll('.position-from-right');
            rightElems.forEach(function (el) {
                el.style.right = left + 'px';
            });

            var leftElems = document.querySelectorAll('.position-from-left');
            leftElems.forEach(function (el) {
                el.style.left = left + 'px';
            });
        }
    }
}
matchheight();

window.addEventListener('resize', function (e) {
    matchheight();
});

window.addEventListener('load', function () {
    matchheight();
});




// Wait for the document to be fully loaded
document.addEventListener("DOMContentLoaded", function() {
    // Delay execution for 100 milliseconds after the DOMContentLoaded event
setTimeout(function() {
    // Find the legend element with class name-option and data-name attribute equal to "Select Size"
    var legendElement = document.querySelector('legend.name-option[data-name="Size"]');

    // Create the button element
    var sizeChartButton = document.createElement('a');
    sizeChartButton.href = "#";
    sizeChartButton.className = "size-chart-btn";
    sizeChartButton.id= "size-chart-btn";
    sizeChartButton.textContent = "Size chart";

    // Append the button after the legend element
    if (legendElement) {
        legendElement.appendChild(sizeChartButton);

      // Event listener for clicking on element with class "product-info"
        var sizeGuideInfoElements = document.querySelectorAll('.size-chart-btn');
        sizeGuideInfoElements.forEach(function(element) {
            element.addEventListener('click', function() {
                activateSizeGuideDrawer();
            });
        });
        
        // Event listener for clicking on element with class "product-info-close"
        var sizeGuideInfoClose = document.querySelector('.size-guide-close');
        if (sizeGuideInfoClose) {
            sizeGuideInfoClose.addEventListener('click', function() {
                deactivateSizeGuideDrawer();
            });
        }
    }



// Function to add class "active" to the product info drawer box
    function activateSizeGuideDrawer() {
        var sizeGuideInfoDrawer = document.getElementById('size-guide-box');
        if (sizeGuideInfoDrawer) {
            sizeGuideInfoDrawer.classList.add('active');
        }
    }

    function deactivateSizeGuideDrawer() {
        var sizeGuideInfoDrawer = document.getElementById('size-guide-box');
        if (sizeGuideInfoDrawer) {
            sizeGuideInfoDrawer.classList.remove('active');
        }
    }

  
// Function to handle changes in the name-variant element
function handleNameVariantChange(mutationsList, observer) {
    for(const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            const swatchGl = document.querySelector('.name-variant').closest('.swatch--gl');
            if (swatchGl) {
                const errorOption = swatchGl.querySelector('.errorOptions');
                if (errorOption) {
                    errorOption.innerHTML = ''; // Remove HTML content
                }
            }
        }
    }
}

  // Select the target node
const targetNode = document.querySelector('.name-variant');

// Options for the observer (which mutations to observe)
const config = { attributes: false, childList: true, subtree: false };

// Create a new observer instance
const observer = new MutationObserver(handleNameVariantChange);

// Start observing the target node for configured mutations
if (targetNode) {
    observer.observe(targetNode, config);
}
}, 3000); // Delay in milliseconds

});

document.addEventListener("DOMContentLoaded", function () {
  const headers = document.querySelectorAll(".footer-section .footer-menu h2");

  headers.forEach(header => {
    header.addEventListener("click", function () {
      const ul = this.nextElementSibling;

      // Close all other open <ul>s (accordion style — optional)
      document.querySelectorAll(".footer-section .footer-menu ul").forEach(otherUl => {
        if (otherUl !== ul) {
          otherUl.style.maxHeight = null;
        }
      });

      // Toggle this one
      if (ul.style.maxHeight) {
        ul.style.maxHeight = null;
      } else {
        ul.style.maxHeight = ul.scrollHeight + "px";
      }
    });
  });
});

